/** Services required for this order — shown inside the Accept step (link page + QR digital quote).
 *  Every service must be answered Required / Not required before Accept; details can be filled now or later from our email. */
import { ServiceBlock } from "@/pages/public/ServiceConfirmPublic";

export const initServices = (checklist) => Object.fromEntries((checklist || []).map((s) => [s.key, { decision: s.decision || "", details: {}, reuse: false }]));
export const servicesMissing = (checklist, state) => (checklist || []).filter((s) => !s.answered && !state[s.key]?.decision).map((s) => s.label);
export const servicesPayload = (state) => Object.fromEntries(Object.entries(state).filter(([, v]) => v.decision).map(([k, v]) => [k, { decision: v.decision, details: v.details || {} }]));

export function AcceptServicesPicker({ checklist, state, setState, lookup }) {
  if (!checklist?.length) return null;
  const missing = servicesMissing(checklist, state);
  return (
    <div className="space-y-3 rounded-2xl border border-slate-200 bg-slate-50 p-3" data-testid="accept-services">
      <div>
        <div className="text-[14px] font-bold text-slate-900">Services required for this order <span className="text-rose-600">*</span></div>
        <p className="text-[12px] text-slate-600">Mark each service Required or Not required. For Required services you can fill the details now, or later from our email. Never enter passwords or admin tokens.</p>
      </div>
      {checklist.map((s) => <ServiceBlock key={s.key} s={{ ...s, details: {} }} v={state[s.key] || { decision: s.decision || "", details: {}, reuse: false }} set={(v) => setState((cur) => ({ ...cur, [s.key]: v }))} lookup={lookup} />)}
      {missing.length > 0 && <p className="text-[12px] font-semibold text-amber-800" data-testid="accept-services-missing">Still to answer: {missing.join(", ")}</p>}
    </div>
  );
}
